import React from 'react';
import { menuData } from '../data/mockData';

const MenuCategory = ({ title, subtitle, items, sauces }) => {
  return (
    <div className="mb-16">
      <h3 
        className="text-3xl md:text-4xl font-bold text-[#D4A85F] mb-2 text-center"
        style={{ fontFamily: "'Crimson Text', serif" }}
      >
        {title}
      </h3>
      {subtitle && (
        <p 
          className="text-gray-400 text-center mb-6 italic"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          ({subtitle})
        </p>
      )}
      {sauces && (
        <p 
          className="text-gray-400 text-center mb-6 text-sm"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {sauces}
        </p>
      )}
      <div className="space-y-4">
        {items && items.map((item, idx) => (
          <div 
            key={idx} 
            className="flex justify-between items-start border-b border-gray-700 pb-3 hover:bg-gray-900/30 px-4 py-2 rounded transition-colors duration-200"
          >
            <div className="flex-1">
              <h4 
                className="text-white font-semibold text-lg"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {item.name}
              </h4>
              {item.description && (
                <p 
                  className="text-gray-400 text-sm mt-1"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {item.description}
                </p>
              )}
            </div>
            {item.price && (
              <span 
                className="text-[#D4A85F] font-bold text-lg ml-4 whitespace-nowrap"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {item.price}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const AccompagnementsSection = ({ data }) => {
  return (
    <div className="mb-16">
      <h3 
        className="text-3xl md:text-4xl font-bold text-[#D4A85F] mb-6 text-center"
        style={{ fontFamily: "'Crimson Text', serif" }}
      >
        {data.title}
      </h3>
      <div className="flex flex-wrap justify-center gap-3">
        {data.items.map((item, idx) => (
          <span 
            key={idx} 
            className="bg-gray-800 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-[#D4A85F] hover:text-black transition-colors duration-200"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            {item.name}
          </span>
        ))}
      </div>
    </div>
  );
};

const PizzetaSection = ({ data }) => {
  return (
    <div className="mb-16">
      <h3 
        className="text-3xl md:text-4xl font-bold text-[#D4A85F] mb-2 text-center"
        style={{ fontFamily: "'Crimson Text', serif" }}
      >
        {data.title}
      </h3>
      <p 
        className="text-[#D4A85F] text-center mb-6 font-bold text-xl"
        style={{ fontFamily: "'Poppins', sans-serif" }}
      >
        {data.subtitle}
      </p>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-gray-800/50 rounded-lg p-4">
          <h4 className="text-white font-semibold mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>Bases</h4>
          <div className="flex flex-wrap gap-2">
            {data.bases.map((item, idx) => (
              <span key={idx} className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-sm">{item}</span>
            ))}
          </div>
        </div>
        <div className="bg-gray-800/50 rounded-lg p-4">
          <h4 className="text-white font-semibold mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>Garnitures</h4>
          <div className="flex flex-wrap gap-2">
            {data.garnitures.map((item, idx) => (
              <span key={idx} className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-sm">{item}</span>
            ))}
          </div>
        </div>
        <div className="bg-gray-800/50 rounded-lg p-4">
          <h4 className="text-white font-semibold mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>Légumes</h4>
          <div className="flex flex-wrap gap-2">
            {data.legumes.map((item, idx) => (
              <span key={idx} className="bg-gray-700 text-gray-300 px-3 py-1 rounded-full text-sm">{item}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MenuSection = () => {
  const menuOrder = [
    { key: 'burgers', data: menuData.burgers },
    { key: 'africanDishes', data: menuData.africanDishes },
    { key: 'grillades', data: menuData.grillades },
    { key: 'accompagnements', data: menuData.accompagnements, isAccompagnements: true },
    { key: 'sandwiches', data: menuData.sandwiches },
    { key: 'bokits', data: menuData.bokits },
    { key: 'pastas', data: menuData.pastas },
    { key: 'salads', data: menuData.salads },
    { key: 'pizzeta', data: menuData.pizzeta, isPizzeta: true },
    { key: 'kidsMenu', data: menuData.kidsMenu },
    { key: 'extras', data: menuData.extras }
  ];

  return (
    <section id="menu" className="py-24 bg-[#0F0F0F]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#3ABEFF] mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Notre Menu
          </h2>
          <p 
            className="text-lg text-gray-400 max-w-2xl mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Découvrez nos spécialités du monde entier
          </p>
        </div>

        {/* Menu Categories */}
        {menuOrder.map((category) => {
          if (category.isAccompagnements) {
            return <AccompagnementsSection key={category.key} data={category.data} />;
          }
          if (category.isPizzeta) {
            return <PizzetaSection key={category.key} data={category.data} />;
          }
          return (
            <MenuCategory
              key={category.key}
              title={category.data.title}
              subtitle={category.data.subtitle}
              items={category.data.items}
              sauces={category.data.sauces}
            />
          );
        })}
      </div>
    </section>
  );
};
